<template>
    <div class="col-lg-4 col-12 col-md-6 card-col">
        <div class="card-ct card-rounded-shadowed">
            <div class="tree-ct">
                <div class="saved-trees text-center">
                    <h3>{{$t('home_environment_trees_title')}}</h3>
                    <div class="count">{{data.tree ? data.tree : 0}} <small>{{$t('home_environment_trees')}}</small></div>
                </div>
                <div class="tree-img-ct">
                    <img :src="require(`@/assets/img/tree/tree-${level - 1}.png`)" alt="">
                </div>
                <div class="savings row">
                    <div class="col-6">
                        <span>{{$t('home_environment_energy_title')}}</span>
                        <div class="value">{{data.kwh ? data.kwh : 0}} <small>{{$t('home_environment_energy')}}</small></div>
                    </div>
                    <div class="col-6">
                        <span>{{$t('home_environment_co2_title') + ' CO'}}<sup>{{'2'}}</sup></span>
                        <div class="value">{{data.co2 ? data.co2 : 0}} <small>{{'kg'}}</small></div>
                    </div>
                    <div class="col-6">
                        <span>{{$t('home_environment_water_title')}}</span>
                        <div class="value">{{data.water ? data.water : 0}} <small>{{$t('home_environment_water')}}</small></div>
                    </div>
                    <div class="col-6">
                        <span>{{$t('home_environment_oxygen_title')}}</span>
                        <div class="value">{{data.oxygen ? data.oxygen : 0}} <small>{{$t('home_environment_oxygen')}}</small></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  components: {
  },
  props: [
      "data", "level"
  ],
  data () {
    return {
    }
  },
  mounted () {
  },
  created () {
  },
  computed: {
  },
  methods: {
  },
  watch: {
  }
}
</script>

<style scoped>
</style>